import React, { useMemo } from "react";

import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";

const SUBJECT = "pixcloud";

export function EnvironmentInformation({}) {
  const isTest = useMemo(() => window.location.host.includes(SUBJECT), []);

  return isTest ? (
    <Box
      style={{
        display: "flex",
        flexGrow: 1,
        backgroundColor: "red",
        margin: "0 20px",
        borderRadius: "10px",
        padding: "10px",
        color: "#FFF",
        justifyContent: "center",
      }}
    >
      <Typography component="span" variant="h6">
        <strong>TESTOVACÍ PROSTŘEDÍ</strong>
      </Typography>
    </Box>
  ) : (
    false
  );
}

export default EnvironmentInformation;
